// 引入组件
import LoginCtrlComponent from './LoginModule/View/Ctrl/LoginCtrl.vue'
import LoginAreaComponent from './LoginModule/View/Area/LoginArea.vue'
import LoginPageComponent from './LoginModule/View/Page/LoginPage.vue'
import RegisterCtrlComponent from './LoginModule/View/Ctrl/RegisterCtrl.vue'
import ZWSHomeComponent from './HomeModule/ZWSHome.vue'
import ZWSHeaderComponent from './HomeModule/Container/ZWSHeader.vue'
import ZWSAsideComponent from './HomeModule/Container/ZWSAside.vue'
import ZWSMainComponent from './HomeModule/Container/ZWSMain.vue'
import ZWSFooterComponent from './HomeModule/Container/ZWSFooter.vue'
import ThemePickerComponent from './Common/ZWSComponent/ThemePicker.vue'
// 定义 Loading 对象
const LoginCtrl = {
  // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
  install (Vue) {
    Vue.component('zws-login-ctrl', LoginCtrlComponent)
  }
}
const LoginArea = {
  install (Vue) {
    Vue.component('zws-login-page', LoginAreaComponent)
  }
}
const LoginPage = {
  install (Vue) {
    Vue.component('zws-login-page', LoginPageComponent)
  }
}
const RegisterCtrl = {
  install (Vue) {
    Vue.component('zws-register-ctrl', RegisterCtrlComponent)
  }
}
const ZWSHome = {
  install (Vue) {
    Vue.component('zws-home', ZWSHomeComponent)
  }
}
const ZWSHeader = {
  install (Vue) {
    Vue.component('zws-header', ZWSHeaderComponent)
  }
}
const ZWSAside = {
  install (Vue) {
    Vue.component('zws-aside', ZWSAsideComponent)
  }
}
const ZWSMain = {
  install (Vue) {
    Vue.component('zws-main', ZWSMainComponent)
  }
}
const ZWSFooter = {
  install (Vue) {
    Vue.component('zws-footer', ZWSFooterComponent)
  }
}
// 动态切换主题色组件
const ThemePicker = {
  install (Vue) {
    Vue.component('theme-picker', ThemePickerComponent)
  }
}
// 导出
export {
  LoginCtrl,
  LoginArea,
  LoginPage,
  RegisterCtrl,
  ZWSHome,
  ZWSHeader,
  ZWSAside,
  ZWSMain,
  ZWSFooter,
  ThemePicker
}



// WEBPACK FOOTER //
// ./third_party/common_app/index.js